import React from "react";
import "./styles.css";
import { Logo } from "../Logo";
import { Button, DropdownButton } from "../Button";
import MobileNavbar from "./MobileNavbar";
import language from "../../language";
import { connect } from "react-redux";
import { ListItem } from "../List";
import { setDefaultLanguage } from "../../actions/Language";
import { getStorage } from "../../utils/storage";
import userPhotoPlaceholder from "../../assets/userPhotoPlaceholder.png";
import { authMenus, nonAuthMenus } from "../../constants/profileMenus";

class Navbar extends React.Component {
  constructor() {
    super();

    this.mobileNavbarRef = React.createRef();

    this.state = {
      showMoreMenus: false,
      user: {},
    };
  }
  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    document.addEventListener("mousedown", this.handleClickOutside.bind(this));

    window.addEventListener("scroll", this.onScroll.bind(this), {
      capture: true,
    });
  };

  onScroll() {
    var landingContainer = document.getElementById("landingContainer");

    const scrollY = landingContainer?.scrollTop;

    const navbar_container = document.getElementById("navbar-container");

    if (navbar_container.classList && scrollY) {
      let nav_class_list = navbar_container.classList;

      if (scrollY > 60) {
        if (navbar_container) {
          nav_class_list.add("navbar-sticky-top");
        }
      } else {
        nav_class_list.remove("navbar-sticky-top");
      }
    }
  }

  handleShowMoreMenus = (e) => {
    e.preventDefault();

    const { type } = this.props;

    if (type === "dashboard") {
      return this.handleToggleSidebar();
    }
    this.setState({ showMoreMenus: !this.state.showMoreMenus });
  };

  handleToggleSidebar() {
    const container = document.getElementById("sidebar-container");

    if (container.classList) {
      let nav_class_list = container.classList;

      if (container && nav_class_list.contains("hide")) {
        nav_class_list.add("show");
        nav_class_list.remove("hide");
      } else if (container && nav_class_list.contains("show")) {
        nav_class_list.add("hide");
        nav_class_list.remove("show");
      }
    }
  }

  handleClickOutside(event) {
    if (
      this.mobileNavbarRef.current &&
      !this.mobileNavbarRef.current.contains(event.target) &&
      this.state.showMoreMenus
    ) {
      this.setState({ showMoreMenus: false });
    }
  }

  render() {
    return (
      <>
        <nav
          className={`landing-navbar-container navbar-sticky-top
           ${this.props.isMenuLight ? "nav-menu-light" : ""}
           ${this.props.isShadowActive ? "navbar-shadow" : ""}
           ${this.props.isLight ? "nav-light" : ""}
          } ${this.props.isTransparent ? "nav-transparent" : ""}`}
          id="navbar-container"
        >
          <div
            className={`${
              this.props.className || "container"
            } menu-landing-container `}
          >
            <div className="left-container">
              <Logo
                className="light"
                handleMenuIconClicked={this.handleShowMoreMenus.bind(this)}
                type={this.props.type}
              />
            </div>
            <div className="right-container">
              <div className="hidden-xs hidden-sm d-flex">
                {nonAuthMenus(this.props.defaultLanguage)?.map((menu, i) => {
                  if (
                    this.state.user.token &&
                    menu.access.includes("protected")
                  ) {
                    return (
                      <Button
                        type="hyperlink"
                        to={menu.route}
                        key={i}
                        text={menu.name}
                        styles={{ minWidth: 100, minHeight: 35 }}
                        className={`btn-transparent ${
                          this.props.isMenuLight ? "light" : ""
                        }`}
                      />
                    );
                  } else if (
                    !this.state.user.token &&
                    menu.access.includes("public")
                  ) {
                    return (
                      <Button
                        type="hyperlink"
                        to={menu.route}
                        key={i}
                        text={menu.name}
                        styles={{ minWidth: 100, minHeight: 35 }}
                        className={`btn-transparent ${
                          this.props.isMenuLight ? "light" : ""
                        }`}
                      />
                    );
                  }
                  return <></>;
                })}
                <DropdownButton
                  text={this.props.defaultLanguage}
                  className={`btn-transparent ${
                    this.props.isMenuLight ? "light" : ""
                  }`}
                  leftImage={language[this.props.defaultLanguage].image}
                >
                  {Object.keys(language).map((key, i) => {
                    return (
                      <ListItem
                        key={i}
                        name={key}
                        onPress={() =>
                          this.props.dispatch(setDefaultLanguage(key))
                        }
                        image={language[key].image}
                        type="span"
                      />
                    );
                  })}
                </DropdownButton>
              </div>
              {this.state.user.accessToken ? (
                <div>
                  <DropdownButton
                    text={this.state?.user?.user?.fullName}
                    className="btn-transparent menu-container-no-shadow"
                    leftImage={userPhotoPlaceholder}
                  >
                    {authMenus(this.props.defaultLanguage).map((el, i) => {
                      return (
                        <ListItem
                          key={i}
                          name={el.name}
                          onPress={el.onPress}
                          icon={el.icon}
                          iconClassName="sm"
                          type="span"
                        />
                      );
                    })}
                  </DropdownButton>
                </div>
              ) : (
                <>
                  {/* <Button
                  text={language[this.props.defaultLanguage].login_text}
                  styles={{ minWidth: 100, minHeight: 35 }}
                  type="link"
                  to="/login"
                /> */}
                </>
              )}
            </div>
          </div>
        </nav>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Navbar);
